// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var JobsController = function ($scope, $http, Job) {
    $scope.filter = { status: 'None', type: '', entity: '', before: '' };

    $scope.areAllJobsSelected = false;
    $scope.selectedJobAction = "";
    $scope.isIndicatorShown = false;

    $scope.load = function () {
        $scope.areAllJobsSelected = false;
        $scope.selectedJobAction = "";
        $scope.isIndicatorShown = false;

        $scope.jobs = Job.query({ status: $scope.filter.status, type: $scope.filter.type, entity: $scope.filter.entity, before: $scope.filter.before});
        Job.getTypes(function(data) { $scope.jobTypes = data; });
    };

    function updateJob(url) {
        $http.post(url, {}).success(function () {
            $scope.jobs = Job.query();
        });
    }

    $scope.requeue = function (id) {
        $scope.confirm("Job", "Are you sure you want to re-queue this job?", updateJob.bind(this, '/api/v1/jobs/' + id));
    };

    $scope.retire = function (id) {
        $scope.confirm("Job", "Are you sure you want to retire this job?", updateJob.bind(this, '/api/v1/jobs/' + id + '/retire'));
    };

    $scope.hold = function (id) {
        $scope.confirm("Job", "Are you sure you want to hold this job?", updateJob.bind(this, '/api/v1/jobs/' + id + '/hold'));
    }

    $scope.load();

    $scope.onAllSelectToggle = function() {
        $scope.areAllJobsSelected = !$scope.areAllJobsSelected;
        for(var i = 0; i < $scope.jobs.length; i++) {
            $scope.jobs[i].isJobSelected = $scope.areAllJobsSelected;
        }

        resetSelectedJobsDropdownSelection();    
    }

    $scope.onJobSelectChange = function(job, $event) {
        job.isJobSelected = !job.isJobSelected;
        resetSelectedJobsDropdownSelection()   
        $event.stopPropagation();
    }

    $scope.toggleJobDetailsVisibility = function(job) {
        job.showDetail = !job.showDetail;
    }

    $scope.isNoJobSelected = function() {
        return $scope.getNumberOfSelectedJobs() === 0;
    }

    $scope.isSelectedJobsApplyButtonDisabled = function() {
        return $scope.isNoJobSelected() || $scope.selectedJobAction === "";
    }

    // An action is offered for the selection only if every selected job allows it, since the batch fails as a whole otherwise
    $scope.canSelectedJobs = function(actionFlag) {
        return $scope.jobs.filter(x => x.isJobSelected).every(x => x[actionFlag]);
    }

    $scope.getNumberOfSelectedJobs = function() {
        var selectedItems = $scope.jobs.filter(x => x.isJobSelected);
        return selectedItems.length;
    }

    $scope.confirmActionsForSelectedJobs = function() {
        var action = "";
        switch($scope.selectedJobAction){
            case "ReQueue" : {
                action = "re-queue";
                break;
            }
            case "Retire" : {
                action = "re-tire";
                break;
            }
            case "Hold" : {
                action = "hold";
                break;
            }
            default: throw new Error("Invalid job action");
        }

        var confirmMessage = "Are you sure you want to " + action + " these Jobs?";
        $scope.confirm("Job", confirmMessage, applySelectedJobsAction);
    }

    var actionFlags = { ReQueue: 'CanBeRequeued', Retire: 'CanBeRetired', Hold: 'CanBeHeld' };

    function resetSelectedJobsDropdownSelection() {
        if($scope.isNoJobSelected() || ($scope.selectedJobAction && !$scope.canSelectedJobs(actionFlags[$scope.selectedJobAction]))) {
            $scope.selectedJobAction = "";
        }      
    }

    function applySelectedJobsAction() {
        var selectedJobs = $scope.jobs.filter(y => y.isJobSelected);
        var ids =  selectedJobs.map(x => x.Job.Id);
        var action = $scope.selectedJobAction;
        $scope.isIndicatorShown = true;

        $http.post('/api/v1/jobs/process', {"JobIds": ids, "JobAction": action}) 
            .then(
                function(response) {
                    $scope.load();
                },
                function(error) {
                    $scope.confirm("Error", "Please navigate the Logs page for the more info.", function(){window.location.href = "/#/logs"});
                    $scope.load();
                }
            );
    }
};
JobsController.$inject = ['$scope', '$http', 'Job'];
